import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateCascadesBurnerStatus',
})
export class TranslateCascadesBurnerStatusPipe implements PipeTransform {
  private readonly onTranslationKey = '+INSTALLATIONS.INSTALLATION.CASCADES_BURNER.STATUS.ON';
  private readonly offTranslationKey = '+INSTALLATIONS.INSTALLATION.CASCADES_BURNER.STATUS.OFF';

  constructor(private translateService: TranslateService) {}

  transform(value: boolean): string {
    if (typeof value === 'boolean') {
      return value
        ? this.translateService.instant(this.onTranslationKey)
        : this.translateService.instant(this.offTranslationKey);
    }

    return '';
  }
}
